import {apiHttpClient} from "@/http/httpClient";
import type {LoginRequest, UserInfoResponse} from "@/models/authentication/authentication-response";
import type {NewPasswordRequest} from "@/models/authentication/new-password-request";
import type {PasswordResetRequest} from "@/models/authentication/password-reset-request";
import type {SwitchOrganizationRequest} from "@/models/authentication/switch-organization";

const END_POINT_LOGIN = 'authentication/login'
const END_POINT_SSO_LOGIN = 'authentication/ssoLogin'
const END_POINT_LOGOUT = 'authentication/logout'
const END_POINT_PASSWORD_RESET = 'authentication/ResetPasswordRequest'
const END_POINT_CREATE_NEW_PASSWORD = 'authentication/CreateNewPassword'
const END_POINT_SWITCH_ORGANIZATION = 'authentication/switchOrganization'
const END_POINT_ME = 'authentication/me'
const END_POINT_ANTI_FORGERY_TOKEN = 'authentication/antiForgeryToken'

export const ssoLogin = (idToken: string) => apiHttpClient().post<UserInfoResponse>(END_POINT_SSO_LOGIN, { idToken })
    .then(response => response)
    .catch(error => error);

export const login = (payload: LoginRequest) => apiHttpClient().post<UserInfoResponse>(END_POINT_LOGIN, payload)
    .then(response => response)
    .catch(error => error);

export const logout = async () =>
  await apiHttpClient().post<UserInfoResponse>(END_POINT_LOGOUT)
    .then(response => response)
    .catch(error => error);


export const passwordResetRequest = (payload: PasswordResetRequest) => apiHttpClient().post(END_POINT_PASSWORD_RESET, payload)
  .then(response => response)
  .catch(error => error);


export const createNewPassword = (payload: NewPasswordRequest) => apiHttpClient().post(END_POINT_CREATE_NEW_PASSWORD, payload)
    .then(response => response)
    .catch(error => error);

export const switchOrganization = (payload: SwitchOrganizationRequest) =>
  apiHttpClient(true).post<UserInfoResponse>(END_POINT_SWITCH_ORGANIZATION, payload)
    .then(response => response)
    .catch(error => error);

export const antiforgeryToken = () =>
  apiHttpClient(true).get<string>(END_POINT_ANTI_FORGERY_TOKEN)
    .then(response => response)
    .catch(error => error);

export const me = () => apiHttpClient(false).get<UserInfoResponse>(END_POINT_ME)
  .then(response => response)
  .catch(error => error);
